import { Box, Grid, Typography } from "@mui/material";
import { CardCore } from "src/Pages/components/CardCore/CardCore";

import { AppTextField } from "src/Pages/components";
import { ButtonCore } from "src/Pages/components/ButtonCore/ButtonCore";
import GppGoodIcon from "@mui/icons-material/GppGood";
import { useContextProfileContext } from "src/Contexts/ContextProfile/ContextProfile";
import { IUpdatePasswordUser } from "src/Contexts/ContextProfile/ContextProfileTypes";
import { ChangeEvent } from "react";
import { UseFormPasswordUser } from "./Hooks/UseFormPasswordUser";

export const FormPasswordUser = () => {
  const { valuesUpdatePasswordUser, setValuesUpdatePasswordUser } =
    useContextProfileContext();

  const { handleSubmit, loading } = UseFormPasswordUser();

  const handleChange =
    (prop: keyof IUpdatePasswordUser) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      setValuesUpdatePasswordUser((eventPrev) => ({
        ...eventPrev,
        [prop]: event.target.value,
      }));
    };

  return (
    <CardCore sxStyle={{ margin: 0 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 5 }}>
        <GppGoodIcon sx={{ mr: 2.3 }} color="warning" />

        <Box sx={{ textAlign: "left" }}>
          <Typography sx={{ fontSize: { xs: "14px", sm: "16px" } }}>
            Senha
          </Typography>
          <Typography sx={{ fontSize: { xs: "12px", sm: "14px" } }}>
            Credenciais do usuário
          </Typography>
        </Box>
      </Box>

      <Grid container item spacing={4} sx={{ mb: 4 }}>
        <Grid item xs={12}>
          <AppTextField
            label="Senha Atual"
            placeholder="Senha Atual"
            fullWidth
            value={valuesUpdatePasswordUser.passwordCurrency}
            onChange={handleChange("passwordCurrency")}
          />
        </Grid>
        <Grid item xs={12}>
          <AppTextField
            label="Nova senha"
            placeholder="Nova senha"
            fullWidth
            value={valuesUpdatePasswordUser.passwordNew}
            onChange={handleChange("passwordNew")}
          />
        </Grid>
        <Grid item xs={12}>
          <AppTextField
            label="Confirmar senha"
            placeholder="Confirmar senha"
            fullWidth
            value={valuesUpdatePasswordUser.newPasswordRepeat}
            onChange={handleChange("newPasswordRepeat")}
          />
        </Grid>
      </Grid>

      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
        }}
      >
        <ButtonCore title="Salvar" onClick={handleSubmit} disabled={loading} />
      </Box>
    </CardCore>
  );
};
